

export function getUnixTimestamp() {
    return Date.now();
}